import { Button } from "@mui/material";

import { useTranslation } from "react-i18next";

import { TooltipWithLock } from "components/TooltipWithLock/TooltipWithLock";

export function NotificationEnableDisableButton({
  enabled,
  inherited,
  hasNoPermission,
  callback,
  type,
}: {
  type: "rule" | "handler";
  enabled: boolean;
  inherited: boolean;
  hasNoPermission: boolean;
  callback: () => void;
}) {
  const { t } = useTranslation();

  const text = enabled ? t("Yes") : t("No");
  const color = enabled ? "primary" : "error";

  if (hasNoPermission) {
    return (
      <TooltipWithLock
        title={
          type === "rule"
            ? t("you_do_not_have_permission_to_update_this_rule")
            : t("you_do_not_have_permission_to_update_this_handler")
        }
      >
        <Button size={"small"} color={color} sx={{ opacity: 0.5 }}>
          {text}
        </Button>
      </TooltipWithLock>
    );
  }

  if (inherited) {
    return (
      <TooltipWithLock
        title={
          type === "rule"
            ? t("this_is_an_inherited_rule_and_cannot_be_updated_in_this_zone")
            : t("this_is_an_inherited_handler_and_cannot_be_updated")
        }
      >
        <Button size={"small"} color={color} sx={{ opacity: 0.5 }}>
          {text}
        </Button>
      </TooltipWithLock>
    );
  }

  return (
    <Button size={"small"} color={color} onClick={() => callback()}>
      {text}
    </Button>
  );
}
